import { Chip } from '@mui/material';
import { colors } from 'Constants/Colors';
import {
  COURSE_STATUS_APPROVED,
  COURSE_STATUS_EXPIRED,
  COURSE_STATUS_PENDING,
  COURSE_STATUS_REJECTED,
} from 'Constants/General';
import { uiTheme } from 'Components/ui';

interface CourseStatusChipProps {
  statusId: string;
  status: string;
}

const getStatusColor = (statusId: string) => {
  switch (statusId) {
    case COURSE_STATUS_APPROVED:
      return colors.GREEN;
    case COURSE_STATUS_PENDING:
      return colors.YELLOW;
    case COURSE_STATUS_REJECTED:
      return colors.RED;
    case COURSE_STATUS_EXPIRED:
      return uiTheme.color.expiredBg;
    default:
      return colors.GRAY;
  }
};

const getStatusTextColor = (statusId: string) => {
  switch (statusId) {
    case COURSE_STATUS_PENDING:
      return 'black';
    case COURSE_STATUS_EXPIRED:
      return uiTheme.color.expiredText;
    default:
      return colors.WHITE;
  }
};

const CourseStatusChip = ({ statusId, status }: CourseStatusChipProps) => {
  return (
    <Chip
      label={status}
      sx={{
        backgroundColor: getStatusColor(statusId),
        color: getStatusTextColor(statusId),
        fontWeight: 'bold',
      }}
    />
  );
};

export default CourseStatusChip;
